import { render, staticRenderFns } from "./AllDocumentCstoPO.vue?vue&type=template&id=5edaf72c&scoped=true&"
import script from "./AllDocumentCstoPO.vue?vue&type=script&lang=js&"
export * from "./AllDocumentCstoPO.vue?vue&type=script&lang=js&"
import style0 from "./AllDocumentCstoPO.vue?vue&type=style&index=0&id=5edaf72c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edaf72c",
  null
  
)

export default component.exports